<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import { ref } from "vue"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useToast } from "@/components/ui/toast/use-toast"
import { links } from "@/store"

const open = ref(false)
const form = useForm({ name: "" })
const { toast } = useToast()

function submit() {
    form.post(links.value.transaction_types_store_path, {
        preserveScroll: true,
        onSuccess() {
            form.reset()
            open.value = false
            toast({ description: "Transaction type successfully added!" })
        },
    })
}
</script>

<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <Button variant="outline">Add type</Button>
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <form @submit.prevent="submit" class="space-y-6">
                <DialogHeader>
                    <DialogTitle>New transaction type</DialogTitle>
                    <DialogDescription>Create an expense category to use when adding transactions.</DialogDescription>
                </DialogHeader>
                <FormField name="name">
                    <FormItem :error="form.errors.name">
                        <FormLabel>Type name</FormLabel>
                        <FormControl>
                            <Input v-model="form.name" placeholder="e.g. Rent" maxlength="255" required />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <DialogFooter>
                    <Button type="button" variant="outline" @click="open = false">Cancel</Button>
                    <Button type="submit" :disabled="form.processing">{{ form.processing ? "Saving…" : "Save type" }}</Button>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>
